<div class="results-item">
  <div class="icon-container">
    <u-icon
      class="icon"
      *ngIf="model.view.icon && !showFallback; else fallback"
      [class]="{ fallback: !model.view.icon }"
      (error)="showFallback = true"
      [model]="{ type: 'img', value: { lightUrl: model.view.icon } }"
      [fallback]="fallbackIcon"
      [styles]="{ width: '20px', height: '20px' }"
    ></u-icon>
    <ng-template #fallback>
      <u-icon class="icon fallback" [model]="fallbackIcon" [styles]="{ width: '16px', height: '16px' }"></u-icon>
    </ng-template>
  </div>
  <div class="main" [ngClass]="{ 'with-subtitle': model.view.subtitle, 'exact-query-item': firstResult }">
    <div class="title">
      <result-title
        [model]="model.view.title"
        [selected]="selected"
        [ngClass]="{ 'with-extra': model.view.titleExtra }"
        [showSingleLineView]="!model.view.subtitle"
      >
      </result-title>

      <div class="extra" *ngIf="model.view.titleExtra?.text" [innerHTML]="model.view.titleExtra?.text"></div>
    </div>
    <div class="subtitle" *ngIf="model.view.subtitle">
      <result-subtitle [model]="model.view.subtitle" [ngClass]="{ 'with-extra': model.view.subtitleExtra }"> </result-subtitle>
      <div class="extra" *ngIf="model.view.subtitleExtra?.text" [innerHTML]="model.view.subtitleExtra?.text | stocks"></div>
    </div>
  </div>
</div>
